import { tv } from '@/common/theme/tv.config';
import { bgVariants } from '@/common/theme/variants';

export const styles = {
  root: tv({
    base: 'grow',
    variants: {
      backgroundColor: bgVariants,
    },
  }),
  values: 'gap-x-md gap-y-lg',
  loading: tv({
    variants: {
      type: {
        primary: 'h-[3.2rem] w-[8rem]',
        secondary: 'h-[2.4rem] w-[8rem]',
      },
    },
  }),
  loadingLabel: 'h-[2rem] min-w-[12rem]',
  loadingIcon: 'h-[3.2rem] w-[3.2rem]',
};
